import {
    DASHBOARD_GENERAL_REPORT_AUTH,
    READ_PERMISSION,
} from 'src/constants/permissions';
import { TCRUD, TPermissionKey } from 'src/interfaces/user';

export const isPermissionAlwaysGranted = (
    permission: TPermissionKey,
    operation: TCRUD
): boolean =>
    permission === DASHBOARD_GENERAL_REPORT_AUTH &&
    operation === READ_PERMISSION;
